import React from 'react';
import { Box, Container, Typography, Button, useTheme } from '@mui/material';
import { keyframes } from '@mui/system';
import Slider from "react-slick";

const banner1 = "/assets/BANNER/Banner Homepage 1.png"
const banner2 = "/assets/BANNER/Banner Homepage 2.png"
const banner3 = "/assets/BANNER/Banner Homepage 3.png"

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

function Hero() {
  const theme = useTheme();

  const sliderSettings = {
    // dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    // slidesToShow: 1,
    // slidesToScroll: 1,
  };
  const images = [banner2, banner3, banner1]

  return (
    <Box
      sx={{
        position: 'relative',
        // bgcolor: 'background.paper',
        pt: 20,
        pb: 8,
        // background: 'linear-gradient(135deg, #1a237e 0%, #000000 100%)',
        // color: 'white',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        // '&::before': {
        //   content: '""',
        //   position: 'absolute',
        //   top: 0,
        //   left: 0,
        //   right: 0,
        //   bottom: 0,
        //   background: `
        //     linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 50%, transparent 100%),
        //     radial-gradient(circle at 20% 150%, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0) 60%)
        //   `,
        //   opacity: 0.8,
        //   zIndex: 0,
        // },
        // '&::after': {
        //   content: '""',
        //   position: 'absolute',
        //   top: 0,
        //   left: 0,
        //   right: 0,
        //   bottom: 0,
        //   // backgroundImage: `url(${bg})`,
        //   // backgroundSize: 'cover',
        //   // backgroundPosition: 'center',
        //   opacity: 0.3,
        //   zIndex: 0,
        // },
      }}
    >
      <Box sx={{
        width: "100%",
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}>
        <Slider {...sliderSettings}>
          {images.map((src, i) => (
            <Box key={i}>
              <img
                src={src}
                style={{
                  minHeight: "100vh",
                  maxHeight: "100vh",
                  objectFit: "cover",
                  width: "100%",
                  filter: "brightness(50%)",
                }}
                alt={"BANNER"}
              />
            </Box>
          ))}
        </Slider>
      </Box>
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ animation: `${fadeIn} 1s ease-out` }}>
          <Typography
            component="h1"
            variant="h2"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              letterSpacing: '0.4rem',
              mb: 3,
              background: 'linear-gradient(45deg, #FFD700, #DAA520)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            RELIABLE <br/>
            EXCELLENT <br/>
            CUSTOMIZABLE
          </Typography>
          {/*<Typography */}
          {/*  variant="h5" */}
          {/*  align="center" */}
          {/*  paragraph*/}
          {/*  sx={{*/}
          {/*    fontWeight: 300,*/}
          {/*    fontSize: { xs: '1.1rem', md: '1.3rem' },*/}
          {/*    letterSpacing: '0.1rem',*/}
          {/*    lineHeight: 1.8,*/}
          {/*    color: 'rgba(255, 255, 255, 0.9)',*/}
          {/*    mb: 6,*/}
          {/*    maxWidth: '800px',*/}
          {/*    mx: 'auto',*/}
          {/*  }}*/}
          {/*>*/}
          {/*  Discover our innovative products that are changing the industry.*/}
          {/*  We're committed to delivering excellence and cutting-edge solutions.*/}
          {/*</Typography>*/}
          {/*<Box */}
          {/*  sx={{ */}
          {/*    mt: 6, */}
          {/*    display: 'flex', */}
          {/*    justifyContent: 'center', */}
          {/*    gap: 3,*/}
          {/*    flexWrap: 'wrap'*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Button */}
          {/*    variant="contained" */}
          {/*    size="large"*/}
          {/*    sx={{*/}
          {/*      bgcolor: '#FFD700',*/}
          {/*      color: '#000000',*/}
          {/*      px: 4,*/}
          {/*      py: 1.5,*/}
          {/*      fontSize: '1rem',*/}
          {/*      textTransform: 'none',*/}
          {/*      borderRadius: '30px',*/}
          {/*      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',*/}
          {/*      transition: 'all 0.3s ease',*/}
          {/*      '&:hover': {*/}
          {/*        bgcolor: '#DAA520',*/}
          {/*        transform: 'translateY(-2px)',*/}
          {/*        boxShadow: '0 6px 25px rgba(0, 0, 0, 0.2)',*/}
          {/*      }*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    Learn More*/}
          {/*  </Button>*/}
          {/*  <Button */}
          {/*    variant="outlined" */}
          {/*    size="large"*/}
          {/*    sx={{*/}
          {/*      color: '#FFD700',*/}
          {/*      borderColor: '#FFD700',*/}
          {/*      px: 4,*/}
          {/*      py: 1.5,*/}
          {/*      fontSize: '1rem',*/}
          {/*      textTransform: 'none',*/}
          {/*      borderRadius: '30px',*/}
          {/*      transition: 'all 0.3s ease',*/}
          {/*      '&:hover': {*/}
          {/*        borderColor: '#DAA520',*/}
          {/*        bgcolor: 'rgba(255, 215, 0, 0.1)',*/}
          {/*        transform: 'translateY(-2px)',*/}
          {/*      }*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    Contact Us*/}
          {/*  </Button>*/}
          {/*</Box>*/}
        </Box>
      </Container>
    </Box>
  );
}

export default Hero;
